export default theme => ({
  root: {
    width: 40,
    height: 40,
    borderRadius: 50,
    backgroundColor: theme.colors.background.utility025,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    flexShrink: 0
  },
  disabled: {
    cursor: 'auto'
  }
});